module.exports = __webpack_public_path__ + "Flag-410.fc6ccbde7bd51a0bfb001a35b52a0747.svg";